module.exports = __webpack_public_path__ + "components/country-flag/static/tt-c626201a9c732d332046525523cabb10.svg";